module.exports = __webpack_public_path__ + "static/media/chatBox2.92351739.svg";